// General purpose helper functions

export const topic_url = (cref: string): string => `/guide/${encodeURIComponent(cref)}`;

export const sku_url = (cref: string): string => `/products/${encodeURIComponent(cref)}`;

export const strip_en = (s: string): string => s.replace('@en:', '');

export const isApplePlatform = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const platformInfo = `${navigator.platform} ${navigator.userAgent}`;
  return /Mac|iPhone|iPad|iPod/i.test(platformInfo);
};

export const getSubmitShortcutLabel = (): string => {
  if (typeof navigator === 'undefined') {
    return 'Ctrl+Enter or Cmd+Enter';
  }

  return isApplePlatform() ? 'Cmd+Enter' : 'Ctrl+Enter';
};

/** Returns a trimmed URL only when it uses a safe http/https scheme. */
export const getSafeHttpUrl = (url?: string): string | null => {
  const normalizedUrl = url?.trim();

  if (!normalizedUrl) {
    return null;
  }

  try {
    const parsedUrl = new URL(normalizedUrl);

    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
      ? parsedUrl.toString()
      : null;
  } catch {
    return null;
  }
};

// This must stay in sync with AI_CREATOR in the backend
export const isLLM = (userId: string): boolean => {
  return userId === 'AI';
};

export const renderTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp);
  const now = new Date();

  if (date.toDateString() === now.toDateString()) {
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds}s`;
    } else if (diffInSeconds < 3600) {
      return `${Math.floor(diffInSeconds / 60)}m`;
    } else {
      return `${Math.floor(diffInSeconds / 3600)}h`;
    }
  }

  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  }

  return date.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
};
